// Dynamic API and WebSocket URLs based on client's window location.
// Use same-origin (empty) so browser requests go to the frontend host (e.g. localhost:3000),
// and Next.js rewrites /api/* to the backend. This works in Docker where the backend
// may not be exposed on the host's port 5000 (e.g. network_mode: host on Mac).
export const API_BASE_URL =
  typeof window !== "undefined"
    ? ""
    : "http://localhost:5000";

// WebSocket connects to backend on port 5000 (Next.js doesn't proxy WebSocket at root).
// When backend port is exposed (e.g. local dev or docker with ports), use :5000.
export const WS_BASE_URL =
  typeof window !== "undefined"
    ? `ws://${window.location.hostname}:5000`
    : "ws://localhost:5000";
